<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hbIf0R/tc-custom/9781453228098.jpg?1733084423310" alt="This image is the cover for the book Orchids"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Orchids
      </h1>
      <p class="bookDescription body article font2">
        <b>As the world closes in around them, two Nazis hide out in a tropical paradise</b><br/>The servants sense something strange about the two old men. They are not sure what business Dr. Langhof and Dr. Ludtz have in El Caliz, but they are certain that whatever they do in their colonial mansion is the work of the devil. Although they do not know the specifics of the two men’s crimes, the servants are right to suspect something sinister.  The men are Nazis, fugitives from international law who fled to this South American haven in the chaotic days after World War II. Langhof brought with him a cache of stolen diamonds, with which he bought their safety from the small nation’s corrupt president. He passes his days cultivating a stunning greenhouse full of orchids, and meditating on the evil acts that fill his past. For now they are safe, but fate has many ways of dealing out justice.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas H. Cook
      </h2>
      
      <p class="authorDescription body article"> THOMAS H. COOK was born in Fort Payne, Alabama. He has been nominated for Edgar Awards seven times in five different categories. He received the Best Novel Edgar, the Barry for Best Novel, and has been nominated for numerous other awards.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress/Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2339b04c